import React from "react";
import { Link } from "react-router-dom";
import { FaInfoCircle, FaEnvelope, FaQuestionCircle } from "react-icons/fa";

// Define props for the Footer component
interface FooterProps {
  className?: string; // Make className optional
}

const Footer: React.FC<FooterProps> = ({ className }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={`bg-gray-800 text-gray-300 py-6 ${className || ""}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row justify-between items-center">
        <div className="text-center sm:text-left mb-4 sm:mb-0">
          <p>&copy; {currentYear} Vorlas. All rights reserved.</p>
        </div>
        <div className="flex space-x-6">
          <Link
            to="/about"
            className="flex items-center hover:text-white hover:underline"
          >
            <FaInfoCircle className="w-4 h-4 mr-1.5" />
            About
          </Link>
          <Link
            to="/contact"
            className="flex items-center hover:text-white hover:underline"
          >
            <FaEnvelope className="w-4 h-4 mr-1.5" />
            Contact Us
          </Link>
          <Link
            to="/help"
            className="flex items-center hover:text-white hover:underline"
          >
            <FaQuestionCircle className="w-4 h-4 mr-1.5" />
            Help
          </Link>
          {/* Add other footer links here if needed */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
